import React, { useState } from "react";
import { aboutdetails } from "../../constants/AboutConstants";
import { aboutdata } from "../../constants/AboutConstants";

const AboutUsFeatures = () => { 
  const [expandedList, setExpandedList] = useState(null);

  const toggleList = (id) => {
      setExpandedList(expandedList === id ? null : id);
  };

  return (
    <>
      <div className="lg:pt-[50px] md:pt-[50px] sm:pt-[50px] max-sm:pt-[55px] md:mb-[60px] lg:mb-[67px] max-sm:mb-[70px]">
        <div id="container" className="lg:ml-[174px] md:ml-[100px] sm:ml-[80px]">
           
          <div className="flex lg:flex-row justify-center items-center max-sm:flex-col">
            <div
              id="img-holder"
              className="w-[45.5%] max-sm:w-full lg:mx-[40px] md:mr-[40px] lg:pt-[50px] md:pt-[110px] sm:pt-[130px] max-sm:px-[30px] max-sm:pt-[13px]"
            >
               <p className="lg:w-[86%] sm:w-[98%] sm:px-[18px] md:w-[84%] max-sm:px-[10px] leading-8 text-primary1 pb-2 text-xl">
                {aboutdata.para}
            </p>
              <img src={aboutdata.img} alt="about description" />    
            </div>
            <div
              id="text-wrap"
              className="lg:pl-95 max-sm:pl-[20px] lg:w-[50%] md:w-[45%] max-sm:w-full text-primary1 items-center justify-center "
            >
            {aboutdetails.map((aboutdetails)=>(
              <div id={aboutdetails.id}>
                <div className="w-[70%] max-sm:w-full">
                  <div className="items-start px-4 py-6 max-md:max-w-full ">
                    {/* first  started */}

                    <div>
                      <div 
                        className="items-center self-stretch flex justify-between gap-2.5 mt-4 max-md:max-w-full max-md:flex-wrap"
                        onClick={()=> toggleList(aboutdetails.id)}
                      >
                        <div className="text-slate-900 text-lg font-semibold leading-6 self-stretch max-md:max-w-full hover:cursor-pointer">
                          {aboutdetails.head}
                        </div>
                        <img
                          loading="lazy" 
                          alt="img"
                          src="https://cdn.builder.io/api/v1/image/assets/TEMP/e0c1995d29c1751a39a02ca10faa0a8b2a20f89de7fc2162d7adfb26ebceff8b?"
                          className="hover:cursor-pointer aspect-square object-contain object-center w-[18px] overflow-hidden self-center shrink-0 max-w-full my-auto"
                        />
                      </div>
                      <div className="items-stretch self-stretch flex w-full justify-between gap-5 mt-1.5 pr-20 max-md:max-w-full max-md:flex-wrap max-md:pr-5"></div>
                      {/* first  ended */}
                      <div className="self-stretch bg-slate-300 flex shrink-0 h-px flex-col mt-4 max-md:max-w-full" />
                      {/* content started */}
                        <div className={`justify-center items-center self-stretch bg-white flex flex-col mt-6 rounded-lg max-md:max-w-full max-md:px-5 ${expandedList === aboutdetails.id ? 'block' : 'hidden'}`}>
                          <p>{aboutdetails.para}</p>
                        </div>
                    </div>
                    {/* content ended */}
                  </div>
                </div>
              </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default AboutUsFeatures;
